import { Button } from "@heroui/react";
import React from "react";

type ButtonGradientProps = {
  children: React.ReactNode;
  onPress?: () => void;
  className?: string;
  color?: "blue" | "purple" | string;
  [key: string]: any;
};

export const ButtonGradient = ({
  children,
  onPress,
  className = "",
  color = "blue",
  ...props
}: ButtonGradientProps) => {
  const gradients: Record<string, string> = {
    blue: "linear-gradient(83.87deg, #87CEEB, #3498db)",
    purple: "linear-gradient(83.87deg, #F54180, #9353D3)",
  };

  const gradient = gradients[color] || gradients.blue;

  return (
    <Button
      onPress={onPress}
      className={className}
      size="sm"
      radius="full"
      style={{
        border: "solid 2px transparent",
        backgroundImage: `linear-gradient(hsl(var(--heroui-background)), hsl(var(--heroui-background))), ${gradient}`,
        backgroundOrigin: "border-box",
        backgroundClip: "padding-box, border-box",
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
